// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { InstrumentConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/Instrument';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useBridgeInstrumentConfigurations: () => UseQueryResult<
  TemplateContract<InstrumentConfiguration>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { bridgeOperator } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryBridgeInstrumentConfigurations', offset, ledgerApi, bridgeOperator],
    queryFn: async () => {
      return ledgerApi.queryBridgeInstrumentConfigurations(offset!, bridgeOperator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useBridgeInstrumentConfigurations;
